export const ANNOTATIONS_TAB = "ANNOTATIONS_TAB"